/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsRestartAodRunRunActionsMutationResponse, AuditReportsRestartAodRunRunActionsPathParams, AuditReportsRestartAodRunRunActions401, AuditReportsRestartAodRunRunActions403, AuditReportsRestartAodRunRunActions404 } from "../models/AuditReportsRestartAodRunRunActions";

export function getAuditReportsRestartAodRunRunActionsUrl(id: AuditReportsRestartAodRunRunActionsPathParams["id"]) {
  const res = { method: 'PUT', url: `/audit-reports/v1/aod-runs/${id}/restart` as const }
  return res
}

/**
 * @description Resets the run to WAITING, deletes its report, and re-enqueues processing. Allowed from COMPLETED_WITH_EXPORT, COMPLETED_WITHOUT_EXPORT, or FAILED.
 * @summary Restart a run
 * {@link /audit-reports/v1/aod-runs/:id/restart}
 */
export async function auditReportsRestartAodRunRunActions(id: AuditReportsRestartAodRunRunActionsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsRestartAodRunRunActionsMutationResponse, ResponseErrorConfig<AuditReportsRestartAodRunRunActions401 | AuditReportsRestartAodRunRunActions403 | AuditReportsRestartAodRunRunActions404>, unknown>({ method : "PUT", url : getAuditReportsRestartAodRunRunActionsUrl(id).url.toString(), ... requestConfig })
  return res.data
}